import { SET_RECEIPTS, SET_RECEIPTS_LOADING, SET_SKIPPED_RECEIPTS } from '@Actions/receiptsActions';
const defaultState = {
    receipts: [],
    receiptsLoading: false,
    receiptsLoaded: false,
    skippedReceipts: []
};
export function receiptsReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_RECEIPTS: {
            return Object.assign(Object.assign({}, state), { receiptsLoading: false, receiptsLoaded: true, receipts: action.payload.map(function (receipt) {
                    return Object.assign(Object.assign({}, receipt), { receiptGroupId: receipt.email_receipt_parent_id || receipt.id });
                }) });
        }
        case SET_RECEIPTS_LOADING: {
            return Object.assign(Object.assign({}, state), { receiptsLoading: action.payload });
        }
        case SET_SKIPPED_RECEIPTS: {
            return Object.assign(Object.assign({}, state), { skippedReceipts: action.payload.map(function (receipt) {
                    return Object.assign(Object.assign({}, receipt), { receiptGroupId: receipt.email_receipt_parent_id || receipt.id });
                }) });
        }
        default:
            return state;
    }
}
